import { Banner } from "@custom-types/BannerModel";

export const SET_BANNERS = "SET_BANNERS";

export const setBanners = (banners: Array<Banner>) => {
    return { type: SET_BANNERS, banners };
};
